import React from 'react';
import './footer.css';

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <p>© 2026 Binary Brains Software Engineering Group. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;